<script lang="ts">
  import {featuresStore} from '@/store';

  let isUpdating = false;

  const handleToggle = async (id: string, enabled: boolean) => {
    isUpdating = true;
    await featuresStore.update(id, !enabled);
    isUpdating = false;
  };

  $: features = $featuresStore;
</script>

<div class="p-4">
  {#each features as feature (feature.id)}
    <div
      class="flex items-center justify-between rounded-lg bg-white p-4 shadow transition-shadow duration-200 hover:shadow-md"
    >
      <div class="space-y-1">
        <h3 class="text-lg font-semibold text-gray-800">{feature.name}</h3>
        <p class="text-sm text-gray-600">{feature.description}</p>
      </div>

      <button
        type="button"
        class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent ring-0 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
        class:bg-sermon-pink={feature.enabled}
        class:bg-gray-200={!feature.enabled}
        class:cursor-wait={isUpdating}
        role="switch"
        aria-checked={feature.enabled}
        aria-label="Toggle {feature.name}"
        on:click={() => handleToggle(feature.id, feature.enabled)}
        tabindex="0"
        disabled={isUpdating}
      >
        <span
          class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
          class:translate-x-5={feature.enabled}
          class:translate-x-0={!feature.enabled}
          aria-hidden="true"
        />
      </button>
    </div>
  {/each}
</div>
